'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TimeoutTransitionGroup = require('./components/TimeoutTransitionGroup.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TimeoutTransitionGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-timeout-transition-group/lib/index.js
// module id = 1201
// module chunks = 0